module.exports = __webpack_public_path__ + "img/small_whale03.49bdc1e7.jpg";